import { offsetTop } from "./functions.js"

export function initBurger() {
  const burgerButtonSelector = ".icon-menu"
  const menuSelector = ".header__menu"
  const innerMenuSelector = '.header__menu-block'
  const header = document.querySelector('.header')
  const additionalOffsetTop = 20

  let isMenuOpen = false
  const menu = document.querySelector(menuSelector);
  const burgerButton = document.querySelector(burgerButtonSelector)
  function toggleMenu() {
    if (isMenuOpen) {
      closeMenu()
    } else {
      openMenu()
    }
  }
  function openMenu() {
    burgerButton.classList.add("_open");
    menu.classList.add("_open");
    document.body.classList.add("_lock");
    isMenuOpen = true
    document.addEventListener('click', closeMenuByMenuLink)
    setTimeout(() => document.addEventListener('click', closeMenuByClickOutsideMenu), 100)
    setTimeout(() => window.addEventListener('resize', closeMenuByResize), 100)
  }
  function closeMenu() {
    burgerButton.classList.remove('_open')
    menu.classList.remove("_open");
    document.body.classList.remove("_lock");
    isMenuOpen = false
    document.removeEventListener('click', closeMenuByClickOutsideMenu)
    window.removeEventListener('resize', closeMenuByResize)
  }
  function closeMenuByMenuLink(e) {
    if(e.target.closest('a') && e.target.closest(menuSelector)) closeMenu()
  }
  function closeMenuByEscapeKey(e) {
    if(e.code === 'Escape') closeMenu()
  }
  function closeMenuByClickOutsideMenu(e) {
    if(!e.target.closest(innerMenuSelector)) closeMenu()
  }
  function closeMenuByResize(){
    if(window.innerWidth > 768) {
      if(isMenuOpen) closeMenu()
    }
  }
  function scrollToTarget(e) {
    const link = e.target.closest('a')
    if (!link || !link.href || !(/https?:\/\/[^/]+\/#.+/).test(link.href)) return
    e.preventDefault()
    const href = link.getAttribute('href')
    let el = document.querySelector(href)
    if(!el) return 
    window.scrollTo(0, offsetTop(el) - header.offsetHeight - additionalOffsetTop)
  }
  document.querySelector(".icon-menu").addEventListener("click", toggleMenu)
  document.addEventListener('keydown', closeMenuByEscapeKey)
  menu.addEventListener('click', scrollToTarget)
  document.querySelector('.text-block__buttons').addEventListener('click', scrollToTarget)
}
